import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/images/logo.svg'


const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-secondary sticky-top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "navbar-brand",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo"
  })
], -1)
const _hoisted_4 = { class: "d-flex align-items-center justify-content-center gap-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNav",
  "aria-controls": "navbarNav",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarNav"
}
const _hoisted_7 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "d-flex justify-content-center align-items-center gap-2" }

import { useNavigationLinks } from "@/composables/navigationLinks";
import LanguageSwitcher from "@/components/misc/language-switcher/LanguageSwitcher.vue";
import GetStartedButton from "@/components/base-components/buttons/GetStartedButton.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavbar',
  setup(__props) {

const { t } = useI18n();

const { navbarLinks } = useNavigationLinks();

const isExternalLink = (to: string) => /^https?:\/\//.test(to);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(LanguageSwitcher, { class: "d-lg-none" })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbarLinks), (link, i) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item text-center me-lg-5",
              key: i
            }, [
              (isExternalLink(link.to))
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "nav-link",
                    href: link.to,
                    target: "_blank",
                    rel: "noopener"
                  }, _toDisplayString(_unref(t)(link.name)), 9, _hoisted_8))
                : (_openBlock(), _createBlock(_component_router_link, {
                    key: 1,
                    class: "nav-link",
                    "aria-current": "page",
                    to: link.to
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(link.name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(GetStartedButton),
          _createVNode(LanguageSwitcher, { class: "d-none d-lg-block" })
        ])
      ])
    ])
  ]))
}
}

})